import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {FlowDetails, OperationState} from '../../services/flowBuilder/models';
import {FlowStepTypes} from '../../services/flowBuilder/utils/flow-step-types.enum';
import {MatMenu, MatMenuTrigger} from '@angular/material/menu';
import {SharedService} from '../../../../core/services/store/shared-store/shared-storage.service';
import {FlowManagerService} from '../../services/flow-manager.service';
import {FlowBuilderService} from '../../services/flowBuilder/flow-builder.service';
import {MatDialog} from '@angular/material/dialog';
import { RolesService } from '../../../../core/services/roles/roles.service';
import {Store} from '@ngrx/store';
import {selectNodeTypesMap} from '../../../../core/state/selectors/flow.selector';
import {Observable} from 'rxjs';

export class NodeEmitter {
  stepId: string;
  stepType: FlowStepTypes;
  nodeType: string;
  parentId: string;
  extraFields: {};

  constructor(stepId: any, stepType: any, nodeType: any, parentId: any, extraFields: {}) {
    this.nodeType = nodeType;
    this.stepId = stepId;
    this.stepType = stepType;
    this.parentId = parentId;
    this.extraFields = extraFields;
  }
}

export class ContextMenu {
  event: MouseEvent;
  stepId: string;
}

export interface OnEnterEvent {
  stepId: string;
  parentId: string;
  stepType: string;
}

@Component({
  selector: 'app-flow-node',
  templateUrl: './flow-node.component.html',
  styleUrls: ['./flow-node.component.scss'],
})
export class FlowNodeComponent implements OnInit, OnChanges {


  constructor(
    public flowManagerService: FlowManagerService,
    private sharedService: SharedService,
    private flowBuilder: FlowBuilderService,
    public rolesService: RolesService,
    public dialog: MatDialog,
    private render: Renderer2,
    private store: Store
  ) {}

  @ViewChild('nodeElement') nodeElement: ElementRef;

  @Input() nodeDetail: FlowDetails;
  @Input() matMenu: MatMenu;
  @Input() contextMenu: MatMenu;
  @Input() pastContextMenu: MatMenu;
  @Input() isTrashCan = false;
  @Input() selectedNode: string;
  @Input() operationState: OperationState;
  @Input() isModal: boolean;
  @Input() activeMode: string;

  @Output() onNodeClick: EventEmitter<NodeEmitter> = new EventEmitter<NodeEmitter>();
  @Output() addNewNode: EventEmitter<any> = new EventEmitter<any>();

  @Output() goToStep: EventEmitter<string> = new EventEmitter<string>();
  @Output() goToFlowEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() onNode: EventEmitter<OnEnterEvent> = new EventEmitter<OnEnterEvent>();

  @ViewChild('menuTrigger', { read: MatMenuTrigger })
  contextMenuTrigger: MatMenuTrigger;

  @ViewChild('pastMenuTrigger', { read: MatMenuTrigger })
  pastContextMenuTrigger: MatMenuTrigger;

  @ViewChild('restoreStepWithChildren', { static: true }) restoreStepWithChildren: TemplateRef<any>;

  contextMenuPosition = { x: 0, y: 0 };
  private onNodeEvent: OnEnterEvent;
  childCounter = 0;
  restoreStepWithChildrenRef;
  restoreNodeDialogData = null;
  nodeNumber;
  stepInfo: any;

  nodeTypes: Observable<{}>;

  cssNode: string;
  nodeClass: string;
  cssExisting: string;

  ngOnInit() {
    this.nodeTypes = this.store.select(selectNodeTypesMap);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.applyStartActiveStyling(changes);
  }

  nodeClicked(
    stepId: string,
    stepType: FlowStepTypes,
    nodeType: string,
    event: any,
    parentId: string
  ) {
    this.onNodeClick.emit(new NodeEmitter(stepId, stepType, nodeType, parentId, {}));
    event.stopPropagation();
  }

  copyAndCutRightClick(event) {
    const canOpenContextMenu =
      this.nodeDetail.displayType !== 'new' &&
      this.nodeDetail.displayType !== 'start' &&
      this.contextMenuTrigger &&
      this.sharedService.getEnvironment() !== 'prod' &&
      this.rolesService.canEditFlows();
    if (canOpenContextMenu) {
      this.rightClickHandler(event);
    }
  }

  pastRightClick(event) {
    if (
      this.nodeDetail.displayType === 'new' &&
      this.pastContextMenuTrigger &&
      this.sharedService.getEnvironment() !== 'prod' &&
      this.rolesService.canEditFlows()
    ) {
      this.rightClickHandler(event);
    }
  }

  rightClickHandler(event) {
    const isNew = this.nodeDetail.displayType === 'new';
    if (isNew && !this.flowBuilder.getOperationState?.operationType) {
      return;
    }
    event.preventDefault();
    this.contextMenuPosition.x = event.layerX;
    this.contextMenuPosition.y = event.layerY;
    this.contextMenuTrigger.menuData = { stepId: this.nodeDetail.nodeId, parentId: this.nodeDetail.parentId, isNew };
    this.contextMenuTrigger.openMenu();
  }

  dragover(event) {
    event.preventDefault();
    const nodeElement = document.getElementById('node-' + this.nodeDetail.nodeId);
    if (nodeElement.classList.contains('new')) {
      nodeElement.classList.add('new-hover');
    }
  }

  dragleave(event) {
    event.preventDefault();
    const nodeElement = document.getElementById('node-' + this.nodeDetail.nodeId);
    if (nodeElement.classList.contains('new-hover')) {
      nodeElement.classList.remove('new-hover');
    }
  }

  drop(event) {
    event.preventDefault();
    this.dragleave(event);
    const nodeType = event.dataTransfer.getData('nodeType');
    const stepType = event.dataTransfer.getData('stepType');
    const nodeData = event.dataTransfer.getData('nodeData');
    const extraFields = {
      imageUrl: event.dataTransfer.getData('extraFieldsImg'),
      providerId: event.dataTransfer.getData('extraFieldsProvider')
    };

    if (nodeData) {
      const nodeJson = JSON.parse(nodeData);
      this.childCounter = this.flowBuilder.getChildrenCount(nodeJson.stepNumber);

      const hasChild = event.dataTransfer.getData('hasChild');
      const nodeDataObj = JSON.parse(nodeData);
      if (hasChild === 'true') {
        this.restoreStepWithChildrenRef = this.dialog.open(this.restoreStepWithChildren, {
          panelClass: 'restoreStepWithChildren',
          width: '484px',
        });
        const data = {
          stepNumber: nodeDataObj.stepNumber,
          parentId: this.nodeDetail.parentId,
          nodeId: this.nodeDetail.nodeId,
        };
        this.setRestoreNodeDialogData(data);
        return;
      }
      this.restoreDeletedStep(nodeDataObj.stepNumber, this.nodeDetail.parentId, this.nodeDetail.nodeId, false);
      return;
    }
    this.addNewNode.emit({
      nodeType,
      stepType,
      nodeId: this.nodeDetail.nodeId,
      extraFields
    });
  }

  restoreDeletedStep(stepId, parentId, filter, restoreChildren) {
    // @ts-ignore
    this.flowBuilder.restoreStep(stepId, parentId, filter, restoreChildren);
  }

  setRestoreNodeDialogData(data) {
    this.restoreNodeDialogData = data;
  }

  clearRestoreNodeDialogData() {
    this.restoreNodeDialogData = null;
  }

  closeRestoreStepWithChildrenModal() {
    this.clearRestoreNodeDialogData();
    this.restoreStepWithChildrenRef.close();
  }

  restoreStep(restoreChildren) {
    const { stepNumber, parentId, nodeId } = this.restoreNodeDialogData;
    this.restoreDeletedStep(stepNumber, parentId, nodeId, restoreChildren);
    this.closeRestoreStepWithChildrenModal();
  }

  getStep(step) {
    return step.includes('step') ? step.replace('step', '') : '';
  }

  checkCutAction() {
    if (
      this.operationState &&
      this.operationState.id === this.nodeDetail.stepNumber &&
      this.operationState.operationType === 'CUT'
    ) {
      return 'node-opacity';
    }
    return '';
  }

  checkErrors(step) {
    if (this.sharedService.getEnvironment() !== 'prod') {
      if (step && this.nodeDetail.displayType !== 'start' && this.nodeDetail.displayType !== 'new') {
        return !this.flowBuilder.checkNodeValid(step);
      }
    }
    return false;
  }

  checkFlowCopied() {
    return this.sharedService.getFlowStatus === 'Copied';
  }

  onEnter(event) {
    this.onNodeEvent = {
      stepId: this.nodeDetail.stepNumber,
      parentId: this.nodeDetail.parentId,
      stepType: this.nodeDetail.stepType,
    };
    this.onNode.emit(this.onNodeEvent);

    const onNodeDrag = this.flowBuilder.getOperationState &&
        this.flowBuilder.getOperationState.operationType &&
        this.nodeDetail.stepType === 'new';
    if (onNodeDrag) {
      const nodeContainer = event.target.querySelector('.node-container');
      const stepNumber = event.target.querySelector('.node-icons-block .step-number');
      nodeContainer.style.background = 'url(../../../assets/svg/new-node-background-hover.svg) no-repeat left center';
      stepNumber.style.border = 'solid 1px var(--clickatell-blue-500)';
    }
  }

  onLeave() {
    if (
      this.flowBuilder.getOperationState &&
      this.flowBuilder.getOperationState.operationType &&
      this.onNodeEvent.stepType === 'new'
    ) {
      document.getElementById(`node-${this.onNodeEvent.stepId}`).style.backgroundImage = '';
      const elem = document.querySelector('.new-node_ .node-icons-block .step-number') as HTMLElement;
      elem.style.border = 'solid 1px var(--clickatell-dark-blue)';
    }
    this.onNodeEvent = undefined;
    this.onNode.emit(this.onNodeEvent);
  }


  checkLoop(stepNumber) {
    return this.flowBuilder.checkLoop(stepNumber);
  }

  applyStartActiveStyling(changes: SimpleChanges) {
    if (changes.selectedNode && this.nodeElement) {
      if (changes.selectedNode && changes.selectedNode.currentValue === 'start') {
        this.render.addClass(document.getElementById('start'), 'selected');
      } else if (changes.selectedNode.previousValue === 'start') {
        this.render.removeClass(document.getElementById('start'), 'selected');
      }
    }

    if (changes.nodeDetail) {
      this.updateNodeDetail(this.nodeDetail);
      this.nodeNumber = this.getStep(this.nodeDetail.stepNumber);
      this.stepInfo = this.flowBuilder.getStep(this.nodeDetail.stepNumber);
    }
  }

  goToFlow(stepNumber) {
    if (this.sharedService.getFlowStatus !== 'Copied') {
      this.goToFlowEmitter.emit(stepNumber);
    }
  }

  goToStepHandler(event, stepNumber) {
    event.preventDefault();
    event.stopPropagation();
    this.goToStep.emit(stepNumber);
  }
  updateNodeDetail (nodeDetails: FlowDetails): void {
    this.cssNode = (this.isTrashCan ? 'trash-node ' : 'node ') + nodeDetails.nodeType + '-node_';
    this.nodeClass = `${this.checkCutAction()} ${this.nodeDetail.stepType} node-container ${this.isModal ? 'modal-node' : ''}`;
    this.cssExisting =  nodeDetails.isExisting ? ' existing-node-background' : '';
  }

  startNodeClicked(event: any, isExisting: boolean) {
    event.stopPropagation();
    this.onNodeClick.emit(new NodeEmitter('start', 'start', 'start', 'start', {}));
    if (isExisting) {
      this.goToStep.emit('start');
    }
  }

}



